import {
    createBudgetDocument,
    createBudgetDocumentSection,
    deleteBudgetDocumentSection,
    updateBudgetDocument,
    updateBudgetDocumentSection,
} from "../../../../../../../services/budget";
import { TCreateBudgetDocumentById } from "../../../../../../../services/budget/create-budget-document";
import { TCreateBudgetDocumentSection } from "../../../../../../../services/budget/create-budget-document-section";
import { TDeleteBudgetDocumentSection } from "../../../../../../../services/budget/delete-budget-document-section";
import { TUpdateBudgetDocumentById } from "../../../../../../../services/budget/update-budget-document";
import { TUpdateBudgetDocumentSection } from "../../../../../../../services/budget/update-budget-document-section";

export function useDocumentsRequest() {
    const handleDeleteDocumentSection = async (
        params: TDeleteBudgetDocumentSection,
        sucessCallback?: () => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await deleteBudgetDocumentSection(params)
            .then(() => (sucessCallback ? sucessCallback() : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    const handleUpdateDocument = async (
        params: TUpdateBudgetDocumentById,
        sucessCallback?: () => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await updateBudgetDocument(params)
            .then(() => (sucessCallback ? sucessCallback() : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    const handleCreateDocument = async (
        params: TCreateBudgetDocumentById,
        sucessCallback?: (resp: any) => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await createBudgetDocument(params)
            .then((resp) => (sucessCallback ? sucessCallback(resp) : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    const handleCreateSection = async (
        params: TCreateBudgetDocumentSection,
        sucessCallback?: () => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await createBudgetDocumentSection(params)
            .then(() => (sucessCallback ? sucessCallback() : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    const handleUpdateSection = async (
        params: TUpdateBudgetDocumentSection,
        sucessCallback?: () => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await updateBudgetDocumentSection(params)
            .then(() => (sucessCallback ? sucessCallback() : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    const handleOrderSection = async (
        params: TUpdateBudgetDocumentSection,
        sucessCallback?: () => void,
        errorCallback?: () => void,
        finallyCallback?: () => void
    ) => {
        await updateBudgetDocumentSection(params)
            .then(() => (sucessCallback ? sucessCallback() : null))
            .catch(() => (errorCallback ? errorCallback() : null))
            .finally(() => (finallyCallback ? finallyCallback() : null));
    };

    return {
        handleCreateDocument,
        handleCreateSection,
        handleDeleteDocumentSection,
        handleOrderSection,
        handleUpdateDocument,
        handleUpdateSection,
    };
}
